module.exports = __webpack_public_path__ + "img/youtube-link-sb.04a6b4e4.jpeg";